import {
  FETCH_AI_WALLETS,
  FETCH_AI_WALLETS_SUCCESS,
  FETCH_AI_WALLETS_FAILURE,
  FETCH_AI_LEDGER,
  FETCH_AI_LEDGER_SUCCESS,
  FETCH_AI_LEDGER_FAILURE,
  FETCH_AI_PLANS,
  FETCH_AI_PLANS_SUCCESS,
  FETCH_AI_PLANS_FAILURE,
  START_AI_CHECKOUT,
  START_AI_CHECKOUT_SUCCESS,
  START_AI_CHECKOUT_FAILURE,
  COMPLETE_AI_CHECKOUT,
  COMPLETE_AI_CHECKOUT_SUCCESS,
  COMPLETE_AI_CHECKOUT_FAILURE,
} from "./constants";

export const fetchAiWallets = (payload) => ({
  type: FETCH_AI_WALLETS,
  payload,
});
export const fetchAiWalletsSuccess = (payload) => ({
  type: FETCH_AI_WALLETS_SUCCESS,
  payload,
});
export const fetchAiWalletsFailure = (payload) => ({
  type: FETCH_AI_WALLETS_FAILURE,
  payload,
});

export const fetchAiLedger = (payload, append = false) => ({
  type: FETCH_AI_LEDGER,
  payload,
  append,
});
export const fetchAiLedgerSuccess = (payload, append = false) => ({
  type: FETCH_AI_LEDGER_SUCCESS,
  payload,
  append,
});
export const fetchAiLedgerFailure = (payload, append = false) => ({
  type: FETCH_AI_LEDGER_FAILURE,
  payload,
  append,
});

export const fetchAiPlans = (payload) => ({
  type: FETCH_AI_PLANS,
  payload,
});
export const fetchAiPlansSuccess = (payload) => ({
  type: FETCH_AI_PLANS_SUCCESS,
  payload,
});
export const fetchAiPlansFailure = (payload) => ({
  type: FETCH_AI_PLANS_FAILURE,
  payload,
});

export const startAiCheckout = (payload) => ({
  type: START_AI_CHECKOUT,
  payload,
});
export const startAiCheckoutSuccess = (payload) => ({
  type: START_AI_CHECKOUT_SUCCESS,
  payload,
});
export const startAiCheckoutFailure = (payload) => ({
  type: START_AI_CHECKOUT_FAILURE,
  payload,
});

export const completeAiCheckout = (payload) => ({
  type: COMPLETE_AI_CHECKOUT,
  payload,
});
export const completeAiCheckoutSuccess = (payload) => ({
  type: COMPLETE_AI_CHECKOUT_SUCCESS,
  payload,
});
export const completeAiCheckoutFailure = (payload) => ({
  type: COMPLETE_AI_CHECKOUT_FAILURE,
  payload,
});
